module.exports = __webpack_public_path__ + "img/imgYLSYB(1).5e80fb26.png";